import React from 'react'
import { useTranslation } from 'react-i18next'
import { Layout } from 'ui/layout/Layout'
import { AppBarPatient } from 'ui/partials/AppBar'
import { Text1 } from 'ui/shorthands/Texts'
import type { MedicalInstitutionProps } from 'types/applicant'
import { PasscodeEntryApiProps } from 'types/applicant'
import { makeStyles } from 'tss-react/mui'
import type { Theme } from '@mui/material/styles'

import { Container } from '@mui/material'
import { StackItem } from 'ui/layout/StackItem'

const useStyles = makeStyles()((theme: Theme) => ({
  category: {
    marginTop: theme.spacing(2),
    backgroundColor: theme.palette.background.paper,
    '&:last-child': {
      marginBottom: theme.spacing(4),
    },
  },
}))

export type ReservationDoneProps = {
  med: MedicalInstitutionProps
  entry: PasscodeEntryApiProps
}

const ReservationCancelled: React.FC<ReservationDoneProps> = ({
  med,
  entry,
}: ReservationDoneProps) => {
  const { t } = useTranslation()
  const { classes } = useStyles()

  return (
    <Layout
      header={
        <AppBarPatient>
          {med.name} {t('予約')}
        </AppBarPatient>
      }
      showFooter
    >
      <Container maxWidth="md">
        <div className={classes.category}>
          <StackItem label={t('予約ID')}>
            <Text1>{entry.reservation_number}</Text1>
          </StackItem>
          <StackItem label={t('ステータス')}>
            <Text1>{t('予約取消')}</Text1>
          </StackItem>
        </div>
      </Container>
    </Layout>
  )
}

export default ReservationCancelled
